{
  "header": {
    "title": {
      "create": "Create price list",
      "edit": "Edit price list"
    },
    "description": {
      "create": "Choose how you want your pricing to work with automatic and manual pricing.",
      "update": "Choose how you want your pricing to work with automatic and manual pricing."
    }
  },
  "details": {
    "title": "Details",
    "name": {
      "label": "Name",
      "placeholder": "e.g. Wholesale pricing"
    },
    "handle": {
      "label": "Handle (or ID)",
      "placeholder": "e.g. wholesale-pricing"
    },
    "currency": {
      "label": "Currency",
      "placeholder": "Please select a currency"
    },
    "no_changing_handle_or_currency": "The price list handle and currency cannot be changed once a price list has been created."
  },
  "automatic_pricing": {
    "title": "Automatic pricing",
    "enable": {
      "label": "Enable automatic pricing",
      "description": "Use another pricing source and apply a discount."
    },
    "pricing_source": {
      "label": "Pricing source",
      "placeholder": "Select a price list",
      "groups": {
        "custom": "Manually created price lists",
        "platform": "Platform price lists",
        "integration": "Integration price lists"
      }
    },
    "percentage_variation": {
      "enable": "Apply a percentage variation",
      "direction": {
        "minus": "Decrease",
        "plus": "Increase"
      },
      "description": "Apply a percentage variation to all pricing in \"{name}\".",
      "tax": {
        "title": "Adjust pricing to handle tax",
        "description": "SparkLayer displays prices exclusive of tax (net pricing). Because your pricing source includes tax, enter your tax rate below. We will automatically adjust the percentage variation above to strip the tax from your displayed prices.",
        "example": "Example: With a 20% tax rate, a {currencySymbol}100 product will be displayed as {currencySymbol}83.33.",
        "adjust": "Adjust pricing"
      }
    },
    "currency_conversion": {
      "enable": {
        "label": "Currency conversion",
        "description": "Use a manual exchange rate for {currency}"
      },
      "same_currency": "Please note: the currency of this price list and the selected source price list are the same ({currency})."
    }
  },
  "manual_pricing": {
    "title": "Manual pricing",
    "description": "Set specific prices for each product by uploading a CSV file.",
    "disabled_alert": {
      "message": "Manual pricing is managed by uploading a CSV file on the price lists page.",
      "price_lists_button": "Go to price lists"
    },
    "enable": {
      "label": "Enable manual pricing",
      "description": "Set specific prices for each product by uploading a CSV file."
    },
    "quantity_pricing": "You can also set up \"quantity pricing\" by adding a column named \"QTY\".",
    "get_started": {
      "single": "To get started, you'll need to set up the following columns in your CSV file.",
      "bulk": "To get started, you'll need to set up the following columns in your CSV file."
    },
    "csv_table_caption": "Example CSV file",
    "download_csv_template": "Download CSV template",
    "errors": {
      "title": "CSV errors",
      "description": "There were issues found, please review these before continuing."
    },
    "file_upload": {
      "hint": "Upload a CSV file or drag a file here."
    }
  },
  "actions": {
    "create": "Create price list",
    "update": "Update price list"
  },
  "notifications": {
    "errors": {
      "select_price_list": "Please select a price list.",
      "create_failed": "Something went wrong while creating this price list.",
      "update_failed": "Something went wrong while updating this price list.",
      "price_list": "There were issues with your price list.",
      "price_list_csv": "There were issues with your price list CSV file.",
      "duplicate_slug": "A price list with this handle already exists.",
      "download": "Failed to download CSV.",
      "tax_adjust": "An error occurred when adjusting for tax. Please ensure the tax value is a valid number."
    },
    "success": {
      "create": "Price list \"{name}\" successfully created.",
      "update": "Price list \"{name}\" successfully updated."
    }
  }
}
